"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.settingsSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    status: 'initial',
};
exports.settingsSlice = (0, toolkit_1.createSlice)({
    name: 'editable-settings',
    initialState,
    reducers: {
        setSettings: (state, action) => {
            state.status = 'done';
            state.error = undefined;
            state.data = action.payload;
        },
        setLoading: (state) => {
            state.status = 'loading';
            state.error = undefined;
        },
        setError: (state, action) => {
            state.status = 'error';
            state.error = action.payload;
            state.data = undefined;
        },
    },
});
